import React, { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import './Console.css';

interface ConsoleLayoutProps {
  title: string;
  children: ReactNode;
}

const ConsoleLayout: React.FC<ConsoleLayoutProps> = ({ title, children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const isAdmin = !!user?.isAdmin;

  return (
    <div className="console-screen">
      <aside className="console-sidebar">
        <div className="console-sidebar-top">
          <div className="console-brand">Console</div>
          <div className="console-nav">
            {/* Admin tab — only visible to users where is_admin=true from /console/me */}
            {isAdmin && (
              <button
                type="button"
                className={`console-nav-item ${location.pathname === '/console/admin' ? 'active' : ''}`}
                onClick={() => navigate('/console/admin')}
              >
                Admin
              </button>
            )}
            {/* Tables, Dashboard, Training — visible to all users with can_access_console=true */}
            <button
              type="button"
              className={`console-nav-item ${location.pathname === '/console/tables' ? 'active' : ''}`}
              onClick={() => navigate('/console/tables')}
            >
              Tables
            </button>
            <button
              type="button"
              className={`console-nav-item ${location.pathname === '/console/dashboard' ? 'active' : ''}`}
              onClick={() => navigate('/console/dashboard')}
            >
              Dashboard
            </button>
            <button
              type="button"
              className={`console-nav-item ${location.pathname === '/console/training' ? 'active' : ''}`}
              onClick={() => navigate('/console/training')}
            >
              Training
            </button>
          </div>
        </div>

        <div className="console-sidebar-bottom">
          <button type="button" className="console-back-btn" onClick={() => navigate('/chat')}>
            Back to Chat
          </button>
          <div className="console-user">{user?.email || user?.userId || 'User'}</div>
        </div>
      </aside>
      <main className="console-main">
        <header className="console-header">
          <h1>{title}</h1>
        </header>
        <section className="console-content">{children}</section>
      </main>
    </div>
  );
};

export default ConsoleLayout;